import {
  Box,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Spinner,
  useDisclosure,
  Badge,
  Flex,
  Tooltip
} from '@chakra-ui/react';
import AppTableWithPagination from 'components/AppTableWithPagination';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import TreeView from 'components/adspresso/TreeView';
import moment from 'moment';
import { truncateString } from 'utils/functions';

function AdspressoTable({ onAdspressoData, isFetching, isLoading, adspressoCampaigns, setCurrentPage, setsearchValue }) {


  const [activeCampaign, setactiveCampaign] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure()


  useEffect(() => {
    if (adspressoCampaigns?.data) {
      onAdspressoData(adspressoCampaigns?.data);
    }
  }, [adspressoCampaigns])

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        Filter: "",
        filter: "",
        Cell: ({ row: { original } }) => (
        <>
          {original.tree && Object.keys(original.tree).length > 0 ? (
            <Text>{original.name}</Text>
          ) : (
            (() => {
              const isLong = original.name.length > 40;
              const displayName = truncateString(original.name, 40);
              const linkPath = original.status === 'DRAFT'
                ? `/launchpad/${original._id}`
                : `/publish-tracking/${original._id}`;

              const linkElement = (
                <Link to={linkPath} style={{ textDecoration: 'underline' }}>
                  {displayName}
                </Link>
              );

              return isLong ? (
                <Tooltip label={original.name} fontSize={'12px'} p={1}>
                  {linkElement}
                </Tooltip>
              ) : (
                linkElement
              );
            })()
          )}
        </>
        ),
      },
      {
        Header: "Ad Account ID",
        accessor: "",
        Filter: "",
        filter: "",
        Cell: ({ row: { original } }) => {
          return (
            <Box>
              {original?.adsAccounts.map((account, index) => (
                <Text key={index} fontSize={'12px'}>{account.adsAccountId}</Text>
              ))}
            </Box>
          )
        }
      },
      {
        Header: "Ad Account Name",
        accessor: "",
        Filter: "",
        filter: "",
        Cell: ({ row: { original } }) => {
          return (
            <Box>
              {original?.adsAccounts.map((account, index) => {
                const name = account.adsAccountName;
                const isLong = name.length > 40;
                const displayName = truncateString(name, 40);

                return isLong ? (
                  <Tooltip key={index} label={name} fontSize={'12px'} p={1}>
                    <Text fontSize={'12px'} cursor="pointer">
                      {displayName}
                    </Text>
                  </Tooltip>
                ) : (
                  <Text key={index} fontSize={'12px'}>
                    {displayName}
                  </Text>
                );
              })}
            </Box>
          )
        }
      },
      {
        Header: "Objective",
        accessor: "objective",
        Filter: "",
        filter: "",
        Cell: ({ row: { original } }) => {
          let objective = '';

          if (original.objective == 'OUTCOME_SALES') {
            objective = 'Sales'
          } else if (original.objective == 'OUTCOME_LEADS') {
            objective = 'Leads'
          } else if (original.objective == 'OUTCOME_APP_PROMOTION') {
            objective = 'App promotion'
          } else if (original.objective == 'OUTCOME_AWARENESS') {
            objective = 'Awareness'
          } else if (original.objective == 'OUTCOME_ENGAGEMENT') {
            objective = 'Engagement'
          } else if (original.objective == 'OUTCOME_TRAFFIC') {
            objective = 'Traffic'
          }
          return (
            <Text>
              {objective}
            </Text>
          )
        }
      },
      {
        Header: "Status",
        accessor: "status",
        Filter: "",
        filter: "",
        Cell: ({ row: { original } }) => {
          let badgeColor = 'gray';
          if (original?.status === 'PENDING') {
            badgeColor = 'yellow';
          } else if (original?.status === 'DRAFT') {
            badgeColor = 'gray';
          } else if (original?.status === 'PUBLISHED') {
            badgeColor = 'green';
          }

          return (
            <>
              <Badge
                fontSize={"10px"}
                marginRight={1}
                colorScheme={badgeColor}
              >
                {original?.status}
              </Badge>
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "createdDate",
        Filter: "",
        filter: "",
        Cell: ({ row: { original } }) => (
          <Text>{moment(original.createdDate).format("DD-MM-YYYY hh:mm A")}</Text>

        ),
      },
    ],
    []
  );

  return (
    <>

      <Modal isOpen={isOpen} onClose={onClose} size={'2xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Campaign tree</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TreeView tree={activeCampaign?.tree} />
          </ModalBody>
          <ModalFooter>
            <Button size={'xs'} mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {isLoading ? (
        <Flex direction={'column'} gap={2} alignItems={'center'} justifyContent={'center'} h={'70vh'}>
            <Spinner />
            <Text>Loading…</Text>
        </Flex>
      ) : (
        <AppTableWithPagination
          columns={columns}
          data={adspressoCampaigns?.data || []}
          paginationMeta={adspressoCampaigns?.meta || {}}
          onPageChange={(index) => setCurrentPage(index)}
          onSearchInputChange={(searchInput) => setsearchValue(searchInput)}
          searchEnabled={true}
          isFetching={isFetching}
          emptyMessage={'Ready to launch? Click ‘Create’ to begin your Ad Campaign creation'}
        // initialState={initialTableState}
        />
      )}
    </>
  )
}


export default AdspressoTable